import $ from 'jquery'

$(document).ready(()=>{
    $('[data-js-process-invoice]').click((e)=>{
        const $el = $(e.target)
        const pnrcode = $el.attr('data-pnrcode')
        const invoiceType = $el.attr('data-invoice-type')
        if( pnrcode ){
            $.ajax({
                type: "GET",
                url: window.AJAX_URL,
                data: {
                    pnrcode,
                    invoice_type: invoiceType,
                    action: 'get_tours_invoice_ajax',
                    _wpnonce: window.AJAX_NONCE,
                },
                success: (data) => {
                    var link = document.createElement('a');
                    const ajax_url = window.AJAX_URL.split('?')[0]
                    link.href = `${ajax_url}?action=get_tours_invoice_ajax&pnrcode=${pnrcode}&_wpnonce=${window.AJAX_NONCE}&invoice_type=${invoiceType}`;
                    link.download = `invoice-${pnrcode}.pdf`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                },
                error: (data) => {
                    alert('ไม่สามารถดาวน์โหลด Invoice ได้ กรุณาลองใหม่อีกครั้งค่ะ');
                }
            })
        }
    })
})